import React from 'react';
import { logError } from '../utils/logger';

/**
 * ErrorBoundary component that catches render errors in child components
 * and displays a fallback UI instead of crashing the entire application.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logError('[ErrorBoundary] Uncaught error in component tree', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      // Use custom fallback if provided
      if (this.props.fallback) {
        return typeof this.props.fallback === 'function'
          ? this.props.fallback({ error: this.state.error, onRetry: this.handleRetry })
          : this.props.fallback;
      }

      // Default fallback UI
      return (
        <div className="error-boundary-fallback" style={{
          padding: '40px 20px',
          textAlign: 'center',
          fontFamily: 'inherit',
        }}>
          <h3 style={{ marginBottom: '12px', color: '#dc2626' }}>
            Something went wrong
          </h3>
          <p style={{ marginBottom: '20px', color: '#6b7280' }}>
            We encountered an unexpected error. Please try again.
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: '10px 24px',
              backgroundColor: '#2563eb',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
